import Root from './containers/Root';

export default (): React.ReactNode => Root;
